var map = {
	"./all.svg": 47973,
	"./arrowDownGrayIcon.svg": 70775,
	"./arrowDownIcon.svg": 60380,
	"./arrowDownSmallIcon.svg": 73566,
	"./arrowLeftIcon.svg": 33081,
	"./arrowRightWhiteIcon.svg": 52557,
	"./arrowUpGrayIcon.svg": 46544,
	"./basketIcon.svg": 47414,
	"./betIcon.svg": 65322,
	"./blueArrowIcon.svg": 13306,
	"./bonusBuy.svg": 41500,
	"./bonusTerms/depNumber.svg": 4928,
	"./bonusTerms/frequency.svg": 61078,
	"./bonusTerms/fsAmount.svg": 56647,
	"./bonusTerms/game.svg": 72145,
	"./bonusTerms/hourglass.svg": 69507,
	"./bonusTerms/info.svg": 91943,
	"./bonusTerms/maxBonus.svg": 38319,
	"./bonusTerms/maxCashout.svg": 83170,
	"./bonusTerms/maxWinFs.svg": 36981,
	"./bonusTerms/minDep.svg": 60327,
	"./bonusTerms/prize.svg": 90068,
	"./bonusTerms/rtp.svg": 21482,
	"./bonusTerms/tick.svg": 80622,
	"./bonusTerms/wager.svg": 82795,
	"./bonusTerms/wagerDark.svg": 40608,
	"./btc.svg": 25070,
	"./burgerIcon.svg": 58448,
	"./casinoIcon.svg": 6099,
	"./casual.svg": 60735,
	"./categoryDefault.svg": 72539,
	"./checkIcon.svg": 37678,
	"./clockIcon.svg": 1806,
	"./closeIcon.svg": 53615,
	"./crossCircleIcon.svg": 8413,
	"./crossGrayIcon.svg": 17467,
	"./crossIcon.svg": 85217,
	"./crossInCircleIcon.svg": 74121,
	"./crossWhiteIcon.svg": 3353,
	"./cup.svg": 69147,
	"./currencyIcon.svg": 84367,
	"./dropdownArrow.svg": 26682,
	"./envelopeIcon.svg": 98881,
	"./equalitySign.svg": 6536,
	"./errorIcon.svg": 79575,
	"./eyeClosedIcon.svg": 19558,
	"./eyeOpenIcon.svg": 73687,
	"./globeIcon.svg": 52881,
	"./grayBetIcon.svg": 64405,
	"./heartFullIcon.svg": 28060,
	"./heartIcon.svg": 57626,
	"./heartIconDouble.svg": 83852,
	"./homeIcon.svg": 4820,
	"./homeStrokeIcon.svg": 5435,
	"./infoIcon.svg": 39923,
	"./infoIconCircle.svg": 25401,
	"./infoIconTooltip.svg": 49887,
	"./jackpot.svg": 19407,
	"./live.svg": 89985,
	"./lockIcon.svg": 53892,
	"./logo.svg": 21579,
	"./logoMin.svg": 37535,
	"./lupIcon.svg": 93378,
	"./lupIcon1.svg": 10352,
	"./magnifier.svg": 73564,
	"./magnifierLargeIcon.svg": 64452,
	"./menuIcon.svg": 28179,
	"./minusIcon.svg": 54381,
	"./moneyBag.svg": 49370,
	"./new.svg": 59617,
	"./newNotificationIcon.svg": 17598,
	"./notificationIcon.svg": 65155,
	"./notificationWithBadgeIcon.svg": 67649,
	"./playIcon.svg": 68826,
	"./plusIcon.svg": 67343,
	"./plusIconBlack.svg": 55029,
	"./plusIconBoldWhite.svg": 12991,
	"./plusIconGrey.svg": 65556,
	"./presentIcon.svg": 38384,
	"./presentSmallIcon.svg": 21408,
	"./prizeIcon1.svg": 31290,
	"./prizePoolBlackIcon.svg": 908,
	"./prizePoolIcon.svg": 91568,
	"./profile/activeSessionsIcon.svg": 31453,
	"./profile/addressIcon.svg": 32369,
	"./profile/arrowSelectIcon.svg": 59976,
	"./profile/changePasswordIcon.svg": 63780,
	"./profile/coolingOffIcon.svg": 55729,
	"./profile/crossIcon.svg": 99140,
	"./profile/depositHistoryRowIcon.svg": 62237,
	"./profile/depositLimitsIcon.svg": 31989,
	"./profile/faileFileUploadIcon.svg": 38405,
	"./profile/fileUploadIcon.svg": 3762,
	"./profile/identityIcon.svg": 94889,
	"./profile/imageIcon.svg": 19233,
	"./profile/linkBoldIcon.svg": 98866,
	"./profile/lossLimitsIcon.svg": 68796,
	"./profile/paymentIcon.svg": 19691,
	"./profile/pdfIcon.svg": 19099,
	"./profile/selfExclusionIcon.svg": 1178,
	"./profile/tooltipIcon.svg": 8348,
	"./profile/trashIcon.svg": 58944,
	"./profile/twoFactorIcon.svg": 93270,
	"./profile/verifyEmailIcon.svg": 49888,
	"./profile/verifyNotificationIcon.svg": 27875,
	"./profile/wagerLimitsIcon.svg": 38225,
	"./profile/withdrawalHistoryRowIcon.svg": 49177,
	"./profileIcon.svg": 50497,
	"./providers1Icon.svg": 22289,
	"./providersIcon.svg": 89761,
	"./randomizeIcon.svg": 86601,
	"./searchGrayIcon.svg": 26202,
	"./searchIcon.svg": 67592,
	"./slots.svg": 25037,
	"./spinsIcon.svg": 5824,
	"./sportsIcon.svg": 33173,
	"./successCircleIcon.svg": 32555,
	"./successIcon.svg": 99830,
	"./supportIcon.svg": 96622,
	"./tabBarMenu/app.svg": 20895,
	"./tabBarMenu/casino.svg": 48282,
	"./tabBarMenu/jackpotTabBar.svg": 29118,
	"./tabBarMenu/lobby.svg": 74447,
	"./tabBarMenu/profile.svg": 81459,
	"./tabBarMenu/promo.svg": 13052,
	"./tabBarMenu/quest.svg": 84342,
	"./tabBarMenu/signout.svg": 44137,
	"./tabBarMenu/sports.svg": 13549,
	"./tabBarMenu/sportsMobileMenuIcon.svg": 9261,
	"./tabBarMenu/tournaments.svg": 1296,
	"./tabBarMenu/vip.svg": 35150,
	"./table.svg": 7926,
	"./termsAndConditionsIcon.svg": 26542,
	"./tickCircleDeclineIcon.svg": 56179,
	"./tickCircleIcon.svg": 25359,
	"./tickCircleIcon1.svg": 2612,
	"./tickIcon.svg": 82854,
	"./tickIcon1.svg": 87803,
	"./topicsIcon.svg": 90482,
	"./trending.svg": 73464,
	"./wagerIcon.svg": 574,
	"./warningIcon.svg": 19887,
	"./whiteArrowRight.svg": 22619,
	"./whiteInfoIcon.svg": 84843,
	"./withdrawalIcon.svg": 45908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7790;